import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Option, MerchantPricingItemBreakdown } from 'apis/restaurant-api/merchant-admin/purchases/types';
import MonetaryAmount from 'common/formatting/MonetaryAmount';

import {
  ItemOption,
  ItemOptionCount,
  ItemOptionPrice,
  ItemOptionValue,
  ItemOptions,
  MultiplicationSign,
} from './PurchaseBreakdown.styled';

const PurchaseBreakdownItemOption = ({
  option,
  merchantPricingItemBreakdown,
}: {
  option: Option;
  merchantPricingItemBreakdown: MerchantPricingItemBreakdown[];
}) => {
  const merchantPricingItemOption = merchantPricingItemBreakdown.find(
    merchantPricingItemBreakdown => merchantPricingItemBreakdown.id === option.id,
  );

  return (
    <ItemOption key={option.id}>
      <ItemOptionCount>
        {parseInt(merchantPricingItemOption?.unit_count ?? '1', 10)} <MultiplicationSign />
      </ItemOptionCount>
      <ItemOptionValue>{option.value}</ItemOptionValue>
      {merchantPricingItemOption && parseFloat(merchantPricingItemOption.unit_price.full_amount.amount) !== 0 && (
        <ItemOptionPrice>
          (
          <MonetaryAmount
            amount={parseFloat(merchantPricingItemOption.unit_price.full_amount.amount)}
            currency={merchantPricingItemOption.unit_price.full_amount.currency}
          />
          )
        </ItemOptionPrice>
      )}
    </ItemOption>
  );
};

const PurchaseBreakdownItemOptions = ({
  options,
  merchantPricingItemBreakdown,
}: {
  options: Option[];
  merchantPricingItemBreakdown: MerchantPricingItemBreakdown[];
}) => {
  const merchantPricingItemDeposit = merchantPricingItemBreakdown.find(
    merchantPricingItemBreakdown => merchantPricingItemBreakdown.type === 'merchant_pov_deposit',
  );

  return (
    <ItemOptions>
      {options.map(option => (
        <PurchaseBreakdownItemOption
          key={option.id}
          option={option}
          merchantPricingItemBreakdown={merchantPricingItemBreakdown}
        />
      ))}
      {merchantPricingItemDeposit && parseFloat(merchantPricingItemDeposit.unit_price.full_amount.amount) !== 0 && (
        <ItemOption>
          <ItemOptionCount>
            {parseInt(merchantPricingItemDeposit?.unit_count ?? '1', 10)} <MultiplicationSign />
          </ItemOptionCount>
          <ItemOptionValue>
            <FormattedMessage id="purchases.deposit" />
          </ItemOptionValue>
          <ItemOptionPrice>
            (
            <MonetaryAmount
              amount={parseFloat(merchantPricingItemDeposit.unit_price.full_amount.amount)}
              currency={merchantPricingItemDeposit.unit_price.full_amount.currency}
            />
            )
          </ItemOptionPrice>
        </ItemOption>
      )}
    </ItemOptions>
  );
};

export default PurchaseBreakdownItemOptions;
